import { render, staticRenderFns } from "./EditMaxParticipantModal.vue?vue&type=template&id=47f9914c&scoped=true"
import script from "./EditMaxParticipantModal.vue?vue&type=script&lang=ts"
export * from "./EditMaxParticipantModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f9914c",
  null
  
)

export default component.exports